export const findFirstCommonElement = (arr1: string[], arr2: string[]) => {
  for (let element of arr1) {
    if (arr2.includes(element)) {
      return element;
    }
  }
  return null;
};
